import TrackingEvent from 'constants/trackingEvents';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { goToEvents, goToHome, goToMembers, pathnames } from 'utils/routerHelpers';
import { canViewMemberList } from 'utils/userHelpers';

import React from 'react';

import { CalendarBlank, House, Users } from '@thinkific/chalk/react-icons';

import { useCommunityContext } from 'components/CommunityContext';

import { BaseSidebar } from './BaseSidebar';
import { SpacesList } from './SpacesList';

export const CommunitySidebar = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { community, trackEvent, currentUser, inLearnerHub, NLACommunitiesEnabled } =
    useCommunityContext();
  if (NLACommunitiesEnabled) return <></>;
  return (
    <BaseSidebar
      navItems={[
        {
          path: pathnames.home,
          label: inLearnerHub ? t('pages-feed_title', 'Feed') : t('pages-home_title', 'Home'),
          icon: House,
          onClick: () => goToHome(router, community.id),
          dataQa: 'home-menu-item',
          dataUserPilotId: 'home-menu-item',
          isVisible: true,
        },
        {
          path: pathnames.events.events,
          label: inLearnerHub
            ? t('pages-community-events_title', 'Community Events')
            : t('pages-events_title', 'Events'),
          icon: CalendarBlank,
          onClick: () => {
            trackEvent(TrackingEvent.CLICK_SEE_ALL_EVENTS);
            goToEvents(router, community.id);
          },
          dataQa: 'events-menu-item',
          dataUserPilotId: 'events-menu-item',
          isVisible: true,
        },
        {
          path: pathnames.members,
          label: t('pages-members_title', 'Members'),
          icon: Users,
          onClick: () => {
            trackEvent(TrackingEvent.CLICK_ALL_MEMBERS_PAGE);
            goToMembers(router, community.id);
          },
          dataQa: 'members-menu-item',
          dataUserPilotId: 'members-menu-item',
          isVisible: canViewMemberList(currentUser),
        },
      ]}
    >
      <SpacesList community={community} currentUser={currentUser} trackEvent={trackEvent} />
    </BaseSidebar>
  );
};

export default CommunitySidebar;
